<template>
  <!-- 初次或之后设置密码弹窗 -->
  <div class="set_password_box">
    <el-dialog v-dialogDragOnly :close-on-click-modal="false" custom-class="set_password_dialog" width='350px' :title="$t(title)" append-to-body :visible="visible" :before-close="hideAdd">
      <div class="clearfix">
        <BaseInfo :option="option" :data="baseData" @save="sureAdd" @cancel="hideAdd" :submitting="submitting" ref="set_password_diaog_ref" class="create-dialog" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BaseInfo from "~/common/components/detail/BaseInfo.vue";
import { mapState } from 'vuex';
export default {
  name: "SetPasswordDialog",
  components: {
    BaseInfo
  },
  props: {
    title: {
      type: String,
      default: 'login.forget_password'
    },
    visible: {
      type: Boolean,
      default: false
    },
    firstTime: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let checkPassword = (rule, value, callback) => {
      let that = this;
      if (value && !/^\d{6}$/.test(value)) {
        callback(new Error(that.$t('portal.qing-shu-ru-6-wei-shuo-shuo-zi')));
      } else {
        callback();
      }
    };
    let checkPassword2 = (rule, value, callback) => {
      let that = this;
      if (value !== this.baseData.new_password) {
        callback(new Error(that.$t('portal.liang-ci-shu-ru-mi-ma-bu-yi-zhi')));
      } else {
        callback();
      }
    };
    return {
      submitting: false,
      option: {
        field: [{
          type: 'text',
          name: 'new_password',
          placeholder: this.$t('portal.xin-zhi-fu-mi-ma'),
          mark: this.$t('tip.please_enter'),
          showPassword: true,
          autocomplete: 'new-password',
          maxlength: 6,
          span: 24
        }, {
          type: 'text',
          name: 'new_password_confirm',
          placeholder: this.$t('portal.xin-mi-ma-que-ren'),
          mark: this.$t('tip.please_enter'),
          showPassword: true,
          autocomplete: 'new-password',
          maxlength: 6,
          span: 24
        }],
        rules: {
          new_password: [{
            required: true,
            trigger: "blur",
            message: this.$t('validate.password')
          }, {
            validator: checkPassword,
            trigger: 'blur'
          }],
          new_password_confirm: [{
            required: true,
            trigger: "blur",
            message: this.$t('validate.password')
          }, {
            validator: checkPassword2,
            trigger: 'blur'
          }]
        },
        isAdd: true,
        isEdit: true,
        isAddHtml: this.$t('button.submit')
      },
      baseData: {
        new_password: '',
        new_password_confirm: ''
      }
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        if (this.firstTime) {
          this.option.field.find(item => item.name === 'new_password').placeholder = this.$t('portal.zhi-fu-mi-ma');
          this.option.field.find(item => item.name === 'new_password_confirm').placeholder = this.$t('portal.que-ren-mi-ma');
        }
      }
    }
  },
  created() {},
  computed: {
    ...mapState({
      userProfile: state => state.login.userProfile
    })
  },
  methods: {
    // 设置密码
    sureAdd(data) {
      this.submitting = true;
      // 保存成功之后，回调关闭弹窗事件，保证执行顺序
      this.$emit('save', data, this.hideAdd);
    },
    hideAdd() {
      this.submitting = false;
      this.$refs.set_password_diaog_ref.resetField();
      this.$emit('hide');
    }
  }
};
</script>

<style lang="less">
.set_password_dialog {
  .clearfix {
    position: relative;
    .el-form-item__content {
      height: 26px;
    }
    .get_verify_code_btn {
      position: absolute;
      top: 51px;
      left: calc(33.33333%);
    }
  }
}
</style>
